<template>
  <page-layout title="지급 명세서 관리">
    <template v-slot:search>
      <payment-manage-search-bar
        @search="getSearch"
      />
    </template>
    <template v-slot:table>
      <payment-manage-table
        :base-ym="baseYm"
        :data="data"
        :loading="loading"
      />
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import PaymentManageSearchBar from "@/pages/Payment/components/PaymentManage/PaymentManageSearchBar.vue";
import PaymentManageTable from "@/pages/Payment/components/PaymentManage/PaymentManageTable.vue";
import {axiosInstance} from "@/util/AxiosModule";

export default {
  name: "PaymentManage",
  components: {PaymentManageTable, PaymentManageSearchBar, PageLayout},
  data() {
    return {
      data: [],
      loading: false,
      baseYm: ""
    }
  },
  methods: {
    async getSearch(params) {
      this.baseYm = params.baseYm;
      try {
        const { data } = await axiosInstance.get("/admin/statement/infoList", { params });
        if (data.length < 1) {
          this.data = [];
        } else {
          this.data = data;
        }
      } catch (error) {
        await this.showAlert({ message: `${error.response.data.message}` });
      }
    }
  }
}
</script>